import React, { useState } from 'react'

import Input, { iInput } from '../Inputs/Input/Input'
import Label from '../Label/Label'
import Backdrop from '../Backdrop'
import useSearch from '../../hooks/SearchContext'
import SendGTAGEvent from '../../utils/sendGTAGEvent'

import { ReactComponent as SearchSvg } from '../../assets/search.svg'
import { ReactComponent as CloseButtonSvg } from '../../assets/ExitDelete.svg'

import {
    Container,
    ContainerSearch,
    Button,
    Row
} from './styles'

interface ISearchModalProps {
    isOpen: boolean;
    onClose: () => void;
    searchedText: string | undefined;
    onSearch: (text: string | undefined) => void;
}

const SearchModal: React.FC<ISearchModalProps> = ({ isOpen, onClose, searchedText, onSearch }) => {

    const [text, setText] = useState<string | undefined>(undefined)
    const { widthWindow } = useSearch()

    const closeSearch = () => {
        onClose()
    }

    const setTextInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setText(e.currentTarget.value)
    }

    const searchTextInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const typedText = e.currentTarget.value
        if (e.key === "Enter" && typedText.length > 0 && searchedText !== typedText) {
            searchItem(e.currentTarget.value)
        }
    }

    const handleSearchClick = () => {
        if (text && text.trim().length > 0) {
            searchItem(text.trim())
        }
    }

    const searchItem = (textItem: string | undefined) => {
        onClose()
        onSearch(textItem)
        SendGTAGEvent(
            'pesquisa_produtos',
            'Pesquisa',
            'Digitou em pesquisar',
            `${textItem}`
        )
    }

    const inputProps: iInput = {
        value: text === undefined ? "" : text,
        autoFocus: true,
        className: 'inputSearch',
        id: 'search',
        notAutoComplete: true,
        placeholder: 'Buscar por descrição ou referência',
        type: 'text',
        onKeyUp: searchTextInput,
        onChange: setTextInput
    }

    return (
        <Container>
            <Backdrop isOpen={isOpen && widthWindow >= 768} onClose={onClose} />

            <ContainerSearch isOpen={isOpen}>
                <Label className='labelSearch' htmlFor='search'>
                    <SearchSvg className='svgSearch' onClick={handleSearchClick} />
                    <Input {...inputProps} />

                    <Button onClick={closeSearch}>
                        <CloseButtonSvg></CloseButtonSvg>
                    </Button>
                </Label>
                <Row />
            </ContainerSearch>

        </Container >
    )
}

export default SearchModal 